(ns common.schema.entities.risk-holding.schema
  (:require
   [common.schema.entities.risk.schema :as risk]
   [common.schema.schema-utils :as su]))


(def schema
  (concat
   risk/schema
   (su/option-field-multi :risk-holding/category
                          "Category"
                          {:authorization su/access-user-user
                           :default-field-visibility :in-use})
   (su/option-field-multi :risk-holding/tags
                          "Tags"
                          {:authorization su/access-user-user
                           :default-field-visibility :in-use})
   (su/text-multiline-field :risk-holding/outcome
                            "Outcome"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})))
